import { IPage } from '../types/IPage';
import RestApiClient from '../RestApiClient';

export const getProfile = async () : Promise<IPage[]> => {    
    const response = await RestApiClient.get<IPage[]>('profile');
    return response;
};
